import { ToastController } from '@ionic/angular';
import { SubSink } from 'subsink';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import * as moment from 'moment';
import { Browser } from '@capacitor/browser';
import { PlatformService } from 'src/app/services/platform/platform.service';

@Component({
  selector: 'app-tips-balance',
  templateUrl: './tips-balance.page.html',
  styleUrls: ['./tips-balance.page.scss'],
})
export class TipsBalancePage implements OnInit {
  subscription = new SubSink();
  moment = moment;
  tipsSent: any = [];
  tipsReceived: any = [];
  viewPerCost: any = [];
  totalBalance: Number = 0;
  totalBalanceVideos: Number = 0;
  public segment: string = "tips-received";
  public arr = new Array(25);
  showSpinner: boolean = false;
  setupAccount: boolean = false;
  isMobileDevice: boolean;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private toast: ToastController,
    private platform: PlatformService
  ) {
    this.isMobileDevice = this.platform.isMobile();
   }

  ngOnInit() {
  }
  segmentChanged(ev: any) {
    this.segment = ev.detail.value;
  }

  ionViewWillEnter(){
    this.tipsSent = [];
    this.tipsReceived = [];
    this.viewPerCost = [];
    this.totalBalance = 0;
    this.totalBalanceVideos = 0;
    this.subscription.sink = this.apiService.get('checkout/balance').subscribe((res) => {
      // console.log("response===============>", res);
      this.tipsSent = res.tipsSend;
      this.tipsReceived = res.tipsReceived;
      this.viewPerCost = res.videosCost;
      this.setupAccount = (res.account && res.account.details_submitted) ? true : false;
      this.calculateTotalBalance(this.tipsReceived);
      this.calculateTotalBalanceVideos(this.viewPerCost);
      // this.myBalance = res['data'];
      // if(this.myBalance.length > 0)
      //   this.calculateTotalBalance(this.myBalance);
    });
  }
  ionViewWillLeave(){
   this.subscription.unsubscribe();
  }

  calculateTotalBalance(data){
    data.map((balance) => {
      this.totalBalance = Number(this.totalBalance) + Number(balance.tip_amount);
    })
  }

  calculateTotalBalanceVideos(data){
    data.map((balance) => {
      // console.log("video ======>", balance);
      this.totalBalanceVideos = Number(this.totalBalanceVideos) + Number(balance.amount);
    });
  }

  convertToNumber(number){
    return Number(number);
  }

  createStripeAccount(){
    this.showSpinner = true;
    this.subscription.sink = this.apiService.post('checkout/connected-account', '').subscribe(async (res) => {
      // console.log("connected", res.url);
      this.showSpinner = false;
      if(res.url.length > 0) {
        await Browser.open({ url: res.url });
      }
    }, (err) => {
      this.showSpinner = false;
      this.presentErrorToast("We are facing some problem while processing your request, Please try again after few moments ")
    })
  }

  async presentErrorToast(toast_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: toast_message,
      position: 'top',
      duration: 5000,
    });
    await toast.present();
  }

}
